module.exports = __webpack_public_path__ + "img/placeholder.3a452a8.png";